export default "__VITE_ASSET__Ce1cevmu__"